module.exports = __webpack_public_path__ + "img/icons_fahrrad_mint.36007dc5.svg";